import InvoiceCard from './InvoiceCard';

export default InvoiceCard;